import { Text } from '@design-system/text';
import FinancialDetailsCollapse from './components/financial-details-collapse';
import BankAddress from './components/bank-address-collapse';
import { useGetBankInfo } from './services/get-bank-info';
import { Button } from '@design-system/button';
import { useNavigate } from 'react-router-dom';
import { Edit } from 'iconsax-react';
import { createRoute, PATHS } from '@src/core/router/paths';
import Loader from '@shared/components/reusables/loader';
import EWalletCollapse from './components/e-wallet-collapse';
import { HasPermission } from '@src/features/roles/guards/has-permission';
import { entities } from '@shared/constants/entities';

const BankInfo = () => {
  const { data, isLoading } = useGetBankInfo();
  const navigate = useNavigate();

  const onClickEdit = (id: number) => {
    navigate(createRoute(PATHS.SETTINGS_BANK_INFO_EDIT(id)));
  };
  const onClickAdd = () => {
    navigate(createRoute(PATHS.SETTINGS_BANK_INFO_NEW));
  };

  if (isLoading) return <Loader />;

  return (
    <div className='px-8 my-6'>
      <div className='flex justify-between items-center mb-6'>
        <Text className='text-gray-800 font-medium text-lg'>Bank Info</Text>
        <div className='flex gap-2'>
          {data?.results[0]?.id ? (
            <HasPermission
              action='change'
              entity={[entities.bankAccount, entities.eWalletAccount]}
            >
              <Button
                variant='primaryOutline'
                size='sm'
                onClick={() => onClickEdit(data?.results[0]?.id)}
              >
                <Edit />
                Edit
              </Button>
            </HasPermission>
          ) : (
            <HasPermission
              action='add'
              entity={[entities.bankAccount, entities.eWalletAccount]}
            >
              <Button
                variant='primaryOutline'
                size='sm'
                onClick={onClickAdd}
              >
                + Add
              </Button>
            </HasPermission>
          )}
        </div>
      </div>
      {data?.results && data?.results.length > 0 ? (
        <>
          <FinancialDetailsCollapse bankInfo={data?.results[0]} />
          <BankAddress bankInfo={data?.results[0]} />
          <EWalletCollapse />
        </>
      ) : (
        <Text className='font-medium text-center text-4xl'>
          No Bank info is found!
        </Text>
      )}
    </div>
  );
};

export default BankInfo;
